$(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

/*
 * Shows a confirmation modal.
 * */
window.confirm_modal = function(action, message, yes_button_text) {
    // set the message to display within the modal
    $('#confirm_modal .modal-body').html(message);

    // if the action is a function
    // execute the function when the 'yes' button is clicked
    if (!!(action && action.constructor && action.call && action.apply)) {
        $("#confirm_modal .modal-yes").unbind('click');

        $("#confirm_modal .modal-yes").one("click", action).one("click", function() {
            $('#confirm_modal').modal('hide');
        });
    }

    // if the action is a string (url),
    // set the url as href for 'yes' button
    else if (typeof action === 'string') {
        $("#confirm_modal .modal-yes").attr('href', action);
    }

    // if a custom text is defined for 'yes' button, set it instead of the default one
    if (typeof yes_button_text === 'string')
        $('#confirm_modal .modal-yes').html(yes_button_text);

    // launch the modal window
    $('#confirm_modal').modal('show');
};

window.parseResponseErrors = function(e) {
    let response_errors = [];

    if (e.response.data !== undefined && e.response.status >= 400 && e.response.status < 500) {
        if (e.response.data.hasOwnProperty('errors')) {
            if (typeof e.response.data.errors === 'object') {
                _.forEach(e.response.data.errors, (error) => {
                    response_errors.push(error);
                });
            } else {
                response_errors.push(...e.response.data.errors);
            }
        } else if (Array.isArray(e.response.data)) {
            response_errors.push(...e.response.data);
        } else if (e.response.data.hasOwnProperty('message')) {
            response_errors.push(e.response.data.message);
        } else {
            response_errors.push(e.response.data);
        }

    } else {
        response_errors.push('Something went wrong. Please contact support.');
    }

    return response_errors;
}
